import React from 'react';
import PropTypes from 'prop-types';

import Container from '../components/Container';
import Flex from '../components/Flex';
import Heading from '../components/Heading';
import Text from '../components/Text';
import Spacing from '../components/Spacing';

import DownloadProgramLink from '../DownloadProgramLink';

const defaultProps = {
  onDownload: null,
};

const propTypes = {
  onDownload: PropTypes.func,
};

const DownloadProgramThankYou = ({
  onDownload,
}) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    className="h-full px-1"
  >
    <Container className="p-4 lg:p-10 text-center">
      <Heading
        level={3}
        className="font-semibold text-4xl"
      >
        ¡Gracias!
      </Heading>
      <Spacing v={4}>
        <Text className="text-sm text-gray-600 mb-2">
          Su descarga del programa oficial de la formación Official Agile Coach está lista.
          Por favor acceda al programa en el siguiente enlace:
        </Text>
      </Spacing>
      <Flex
        justifyContent="center"
        className="pt-4"
      >
        <DownloadProgramLink
          onClick={onDownload}
        />
      </Flex>
    </Container>
  </Flex>
);

DownloadProgramThankYou.defaultProps = defaultProps;
DownloadProgramThankYou.propTypes = propTypes;

export default DownloadProgramThankYou;
